
import { useEffect } from "react";
import { ActionButton } from "../../../components/Forms/ActionButton";
import InputField from "../../../components/Forms/InputField";
import MediaUpload from "../../../components/Forms/MediaUpload";
import RichTextEditor from "../../../components/Forms/RichTextEditor";
import TipsSection from "./TipsSection";
import Select from 'react-select';
import { useGetAppDisplayConfig } from '../../../queries/homepageOrganizer';
import Dropdown from "../../../components/Forms/Dropdown";

const ChallengeInformation = ({
    navigate, active,
    name, setName,
    category, setCategory,
    complexity, setComplexity,
    suggestedBy, setSuggestedBy,
    disabledFriendly, setDisabledFriendly,
    recurrent, setRecurrent,
    recurrentDuration, setRecurrentDuration,
    typeOfFrequency, setTypeOfFrequency,
    frequency, setFrequency,
    startDate, setStartDate,
    endDate, setEndDate,
    description, setDescription,
    inspireMe, setInspireMe,
    rewardDetails, setRewardDetails,
    bonusPoints, setBonusPoints,
    sponsoredPoints, setSponsoredPoints,
    totalPoints, setTotalPoints,
    handleChallengeInformationSubmit,
    tips, setTips,
    submissionButtonType, setSubmissionButtonType,
    coverImage, setCoverImage,
    stateCoverImage, setStateCoverImage,
    errors,
    categoryData, usersData,
    carbonEmissionCount, setCarbonEmissionCount,
    carbonEmissionInfo, setCarbonEmissionInfo,
    bonusDetails, setBonusDetails,
    handleSaveDraft,
    carbonSavingPoints, setCarbonSavingPoints
}) => {

    const { data: homePageConfig } = useGetAppDisplayConfig();

    useEffect(() => {
        setRecurrent('one-time');
        if (!frequency) {
            setFrequency('once');
        }
    }, []);

    return (
        <form className='mt-7'>
            <div className="max-md:mr-1.5 max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col">
                    <div className='flex flex-col w-full gap-3'>
                        <InputField
                            label="Name Of Challenge"
                            name="name"
                            value={name}
                            placeholder="Enter Name Of Challenge"
                            type="text"
                            required={active}
                            onChange={(e) => setName(e.target.value)}
                        />
                        {errors.includes('Name Of Challenge') && (
                            <span className="text-red text-sm font-bold">Name Of Challenge is required</span>
                        )}
                        <div className='flex gap-3 mt-3'>
                            <div className="basis-1/2">
                                <InputField
                                    label="Challenge Category"
                                    name="category"
                                    value={category}
                                    placeholder="Select Challenge Category"
                                    type="select"
                                    required={active}
                                    data={categoryData.map(cat => ({ value: cat._id, placeholder: cat.name }))}
                                    onChange={(e) => {
                                        setCategory(e.target.value);
                                    }}
                                />
                                {errors.includes('Challenge Category') && (
                                    <span className="text-red text-sm font-bold">Challenge Category is required</span>
                                )}
                            </div>
                            <InputField
                                label="Challenge Complexity"
                                name="complexity"
                                value={complexity}
                                placeholder="Select Challenge Complexity"
                                type="select"
                                data={[
                                    { value: 'easy', placeholder: 'Easy' },
                                    { value: 'moderate', placeholder: 'Moderate' },
                                    { value: 'hard', placeholder: 'Hard' },
                                ]}
                                onChange={(e) => setComplexity(e.target.value)}
                            />
                        </div>
                        <div className='flex gap-3 mt-3'>
                            <InputField
                                label="Challenge Idea Suggested By"
                                name="suggestedBy"
                                // value={suggestedBy ? { value: suggestedBy, label: usersData.find(user => user._id === suggestedBy)?.displayName ?? usersData.find(user => user._id === suggestedBy)?.username } : null}
                                value={suggestedBy || ''}
                                placeholder="Select Idea Suggested By"
                                type="select"
                                data={usersData.map(user => ({ value: user._id, placeholder: user.username }))}
                                // onChange={(selectedOption) => setSuggestedBy(selectedOption.value)}
                                onChange={(e) => {
                                    setSuggestedBy(e.target.value);
                                }}
                            />
                            {/* <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2">
                                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                                    Challenge Idea Suggested By
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <select
                                        className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
                                        name={suggestedBy}
                                        onChange={(e) => {
                                            setSuggestedBy(e.target.value);
                                        }}
                                        value={suggestedBy || ''}
                                    >
                                        <option value={''}>{"Select Idea Suggested By"}</option>
                                        {usersData.map(user => ({ value: user._id, placeholder: user.displayName ?? user.username })).map((d, index) => (
                                            <option value={d.value} key={index} defaultValue={d.selected ? true : false}>{d.placeholder}</option>
                                        ))}
                                    </select>
                                </div>
                            </div> */}
                            <InputField
                                label="Inclusive"
                                name="disabledFriendly"
                                value={disabledFriendly}
                                placeholder="Select Inclusive"
                                type="select"
                                data={[
                                    { value: 'true', placeholder: 'Yes' },
                                    { value: 'false', placeholder: 'No' },
                                ]}
                                onChange={(e) => setDisabledFriendly(e.target.value)}
                            />
                        </div>
                        <div className='flex gap-3 mt-3'>
                            <div className="basis-1/2">
                                <InputField
                                    label="Type Of Challenge"
                                    name="recurrent"
                                    value={recurrent || 'one-time'}
                                    placeholder="Select Type Of Challenge"
                                    type="select"
                                    required={active}
                                    data={[
                                        { value: 'one-time', placeholder: 'One Time' },
                                        // { value: 'recurrent', placeholder: 'Recurrent' },
                                    ]}
                                    onChange={(e) => setRecurrent(e.target.value)}
                                    defaultValue={{ value: 'one-time', label: 'One Time' }}
                                />
                                {/* <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2">
                                    <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                                        {"Type of Challenge"}
                                    </label>
                                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <Select
                                            options={[
                                                { value: 'one-time', label: 'one-time' },
                                                // { value: 'recurrent', label: 'Recurrent' },
                                            ]}
                                            className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                            name={'recurrent'}
                                            onChange={e => setRecurrent(e)}
                                            value={{ value: 'one-time', label: 'one-time' }}
                                            defaultValue={{ value: 'one-time', label: 'one-time' }}
                                            placeholder={'Type of Challenge'}
                                            isMulti={false}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    backgroundColor: 'transparent',
                                                    border: '1px solid rgba(224, 230, 237, 1)',
                                                    borderRadius: '0.375rem',
                                                    boxShadow: 'none',
                                                    padding: '0.25rem',
                                                    ":hover": {
                                                        borderColor: '#16ad3c',
                                                    },
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                option: (base, { isSelected }) => ({
                                                    ...base,
                                                    backgroundColor: isSelected ? '#16ad3c' : 'white', // Custom background for selected option
                                                    color: isSelected ? 'white' : 'black', // Custom text color for selected option
                                                    ":active": {
                                                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)', // Active state
                                                    },
                                                    ":hover": {
                                                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)', // Hover state
                                                    },
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: 'black',
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: 'gray',
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    color: 'gray',
                                                }),
                                                indicatorSeparator: (base) => ({
                                                    ...base,
                                                    display: 'none',
                                                }),
                                                clearIndicator: (base) => ({
                                                    ...base,
                                                    color: 'gray',
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    padding: '0.25rem',
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    color: 'black',
                                                }),
                                                menuList: (base) => ({
                                                    ...base,
                                                    maxHeight: '200px',
                                                }),
                                            }}
                                        />
                                    </div>
                                </div> */}
                                {errors.includes('Type Of Challenge') && (
                                    <span className="text-red text-sm font-bold">Type Of Challenge is required</span>
                                )}
                            </div>
                            <InputField
                                label="Challenge Submission Frequency"
                                name="recurrentDuration"
                                value={frequency || 'once'}
                                placeholder="Select Challenge Submission Frequency"
                                type="select"
                                data={[
                                    { value: 'once', placeholder: 'Once' },
                                ]}
                                onChange={(e) => setFrequency(e.target.value)}
                                defaultValue={{ value: 'once', label: 'Once' }}
                            />
                        </div>
                    </div>
                    <MediaUpload
                        label="Cover Photo"
                        id="coverImage"
                        setImageUpload={setCoverImage}
                        existingImage={coverImage}
                        stateImage={stateCoverImage}
                        setStateImageUpload={setStateCoverImage}
                        useFileObject={true}
                    />
                </div>
                <div className='gap-3 mt-3 hidden'>
                    <InputField
                        label="Type Of Frequency"
                        name="typeOfFrequency"
                        value={typeOfFrequency}
                        placeholder="Select Type Of Frequency"
                        type="select"
                        data={[
                            { value: 'fixed', placeholder: 'Fixed' },
                            { value: 'flexible', placeholder: 'Flexible' },
                        ]}
                        onChange={(e) => setTypeOfFrequency(e.target.value)}
                    />
                    <InputField
                        label="Frequency"
                        name="frequency"
                        value={frequency}
                        placeholder="Enter Frequency"
                        type="select"
                        data={[]}
                        onChange={(e) => setFrequency(e.target.value)}
                    />
                </div>
                <div className='flex gap-3 mt-3'>
                    <InputField
                        label="Start Date"
                        name="startDate"
                        value={startDate}
                        placeholder="Enter Start Date"
                        type="date"
                        onChange={(e) => setStartDate(e.target.value)}
                        setSingleValueAsDefault={true}
                    />
                    <InputField
                        label="End Date"
                        name="endDate"
                        value={endDate}
                        placeholder="Enter End Date"
                        type="date"
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                    {/* <InputField
                        label="Bonus Points"
                        name="bonusPoints"
                        value={bonusPoints}
                        placeholder="Enter Bonus Points"
                        type="number"
                        disabled={true}
                        onChange={(e) => setBonusPoints(e.target.value)}
                    /> */}
                    <InputField
                        label="Estd. Carbon Saving in KGs"
                        name="carbonEmissionCount"
                        value={carbonEmissionCount}
                        placeholder="Enter Estimated Carbon Saving in KGs"
                        type="number"
                        onChange={(e) => {
                            setCarbonEmissionCount(e.target.value);
                            setCarbonSavingPoints(e.target.value * homePageConfig?.carbonSavingPointsPerKg);
                        }}
                    />
                    <InputField
                        label={`Estd. Carbon Saving Pts`}
                        subScriptHeading={` (1 KG = ${homePageConfig?.carbonSavingPointsPerKg} pts)`}
                        name="carbonSavingPoints"
                        value={carbonSavingPoints}
                        placeholder="Enter Estimated Carbon Saving Points"
                        type="number"
                        onChange={(e) => setCarbonSavingPoints(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex flex-col w-full max-md:mr-1.5 max-md:max-w-full">
                <div className="flex flex-col gap-3 mt-3">
                    <div className="w-full flex gap-3">
                        <RichTextEditor
                            label="Challenge Description"
                            value={description}
                            placeholder="Enter Challenge Description"
                            onChange={setDescription}
                            required={active}
                            defaultValue={description}
                        />
                        <RichTextEditor
                            label="Inspire Me"
                            value={inspireMe}
                            placeholder="Enter Inspire Me"
                            onChange={setInspireMe}
                        />
                        <RichTextEditor
                            label="Estimated Carbon Saving Calculation"
                            value={carbonEmissionInfo}
                            placeholder="Enter Estimated Carbon Saving Calculation"
                            onChange={setCarbonEmissionInfo}
                        />
                    </div>
                    <div className="w-full flex gap-3">
                        <RichTextEditor
                            label="Reward Details"
                            value={rewardDetails}
                            placeholder="Enter Reward Details"
                            onChange={setRewardDetails}
                        />
                        <RichTextEditor
                            label="Heads UP!"
                            value={bonusDetails}
                            placeholder="Enter Bonus Details"
                            onChange={setBonusDetails}
                        />
                    </div>
                </div>
            </div>

            <div className='mt-5'>
                <div className="my-auto text-lg font-semibold mb-2">Tips</div>
                <TipsSection
                    active={active}
                    tips={tips}
                    setTips={setTips}
                    errors={errors}
                />
            </div>

            <div className='flex justify-between mt-10'>
                <ActionButton variant={'reset'} text={'Reset'} />
                <div className='flex gap-2.5'>
                    {
                        !active &&
                        <div className='flex justify-end'>
                            <ActionButton
                                text={'Save Draft'}
                                variant={'white'}
                                handleSubmit={handleSaveDraft}
                            />
                        </div>
                    }
                    <ActionButton variant={'cancel'} text={'Cancel'} handleSubmit={() => navigate('/challenges/challenges-main/view-challenges')} />
                    <ActionButton variant={'submit'} isSubmit={true} text={'Next >'} handleSubmit={handleChallengeInformationSubmit} />
                </div>
            </div>
        </form>
    );
}

export default ChallengeInformation;